import { store } from '@/firebase'
import {
  CollectionName,
  FSBookingPageMetaData
} from '@WombatTechnology/nitte-time-lib'
import {
  CollectionReference,
  Timestamp,
  collection,
  deleteDoc,
  doc,
  DocumentData,
  setDoc
} from 'firebase/firestore'

export class BookingPageMeataData {
  static doc(uid: string, pageId: string) {
    return doc<FSBookingPageMetaData<Timestamp>, DocumentData>(
      this.collection(uid),
      pageId
    )
  }

  static collection(uid: string) {
    return collection(
      store,
      `${CollectionName.Users}/${uid}/${CollectionName.BookingPageMeataData}`
    ) as CollectionReference<FSBookingPageMetaData<Timestamp>>
  }

  static async create(uid: string, pageId: string) {
    return setDoc(this.doc(uid, pageId), {
      bookingCount: 0,
      unavailableNotifiedAt: null
    })
  }

  static async delete(uid: string, pageId: string) {
    return deleteDoc(this.doc(uid, pageId))
  }
}
